import { render, staticRenderFns } from "./ClientUpdatePage.vue?vue&type=template&id=6680d8f1"
import script from "./ClientUpdatePage.vue?vue&type=script&lang=js"
export * from "./ClientUpdatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports